<ng-container *ngIf="timeSpans?.length >0">
    <div class="horizontal-timeline-main-row" [style.width.px]="width">
        <div class="col no-side-padding span-container" *ngFor="let span of timeSpans">
            <div class="row timespan-row">
                <div class="col no-side-padding timespans-col" [style.height.px]="height"
                    [style.min-width.px]="span.width" [style.background]="span.backgroundColor" #tooltip="matTooltip"
                    [matTooltip]="span.spanTooltipText" [matTooltipPosition]="'above'" matTooltipClass="marker-tooltip"
                    matTooltipShowDelay="1000">

                </div>
                <mat-icon svgIcon="timeline-marker" *ngIf="span.marker" class="col marker" [ngClass]="marker.cssClass"
                    [timelineMarker]="span" [barHeight]="height" #tooltip="matTooltip" [matTooltip]="markerTooltipData"
                    [matTooltipPosition]="'above'" matTooltipClass="marker-tooltip" matTooltipShowDelay="1000">
                </mat-icon>
            </div>
        </div>
    </div>
</ng-container>
